"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardAvatarWrap = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
function shouldForwardProp(prop) {
  return prop !== "mode";
}
const ContactCardAvatarWrap = (0, _styled.default)("div", {
  shouldForwardProp
})`
    padding-right: ${props => props.mode === "normal" ? 16 : 12}px;
    // Allows this container to only take up the room the Avatar needs.
    display: flex;
`;
exports.ContactCardAvatarWrap = ContactCardAvatarWrap;
//# sourceMappingURL=ContactCardAvatarWrap.js.map